"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 16 18';

var Trash = function Trash() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M10.5672,17.78877 L3.8857,17.78877 C2.686075,17.78877 1.7052,16.77987 1.7052,15.54597 L1.7052,5.29137 L12.7477,5.29137 L12.7477,15.54597 C12.7477,16.77987 11.76595,17.78877 10.5672,17.78877"
  }), _react["default"].createElement("path", {
    d: "M9.6991125,2.41056 L9.6991125,1.65186 C9.6991125,1.08846 9.2511125,0.62856 8.7042375,0.62856 L5.7484875,0.62856 C5.2016125,0.62856 4.7544875,1.08846 4.7544875,1.65186 L4.7544875,2.41056 L0.7959875,2.41056 L0.7959875,3.72096 L13.6567375,3.72096 L13.6567375,2.41056 L9.6991125,2.41056 Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Trash, {
  viewBox: viewBox
});

exports["default"] = _default;